import React from 'react';
import { FaseCategoriaTorneio } from '../../../services/categoriaTorneioService';
import { PartidaLite } from '../../../services/faseGrupoPartidasService';

interface ChavePrintSectionProps {
  fase: FaseCategoriaTorneio;
}

const ChavePrintSection: React.FC<ChavePrintSectionProps> = ({ fase }) => {
  const formatDateTime = (dateString: string): string => {
    const date = new Date(dateString);
    const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
    const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    const day = days[date.getDay()];
    const dayNum = date.getDate().toString().padStart(2, '0');
    const month = months[date.getMonth()];
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}, ${dayNum}/${month} às ${hours}:${minutes}hs`;
  };

  const formatPlacar = (partida: PartidaLite): string => {
    if (partida.equipeAWO || partida.equipeBWO) {
      return 'W.O.';
    }
    if (partida.placar?.resultadoFinalA !== null && partida.placar?.resultadoFinalA !== undefined &&
        partida.placar?.resultadoFinalB !== null && partida.placar?.resultadoFinalB !== undefined) {
      return `${partida.placar.resultadoFinalA}/${partida.placar.resultadoFinalB}`;
    }
    return '';
  };

  const formatAtletasNames = (equipe: PartidaLite['equipeA']): string => {
    if (!equipe) return '';
    if (equipe.atletas && equipe.atletas.length > 0) {
      return equipe.atletas.map(a => a.usuario?.nome ?? 'Atleta').join(' / ');
    }
    return equipe.nome || '';
  };

  const sortedPartidas = [...(fase.partidas || [])].sort((a, b) => 
    (a.numeroPartida ?? 0) - (b.numeroPartida ?? 0)
  );

  return (
    <div className="print-fase">
      <div className="print-fase-title">{fase.nome}</div>
      
      {sortedPartidas.length > 0 ? (
        <table className="print-table">
          <thead>
            <tr>
              <th>#</th>
              <th>DATA/HORA</th>
              <th>JOGADORES 01</th>
              <th>PLACAR</th>
              <th>JOGADORES 02</th>
            </tr>
          </thead>
          <tbody>
            {sortedPartidas.map(partida => (
              <tr key={partida.id}>
                <td>{partida.numeroPartida ?? '-'}</td>
                <td>{partida.data ? formatDateTime(partida.data) : '-'}</td>
                <td style={{ textAlign: 'left' }}>{formatAtletasNames(partida.equipeA) || 'A DEFINIR'}</td>
                <td>{formatPlacar(partida)}</td>
                <td style={{ textAlign: 'left' }}>{formatAtletasNames(partida.equipeB) || 'A DEFINIR'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div>Nenhuma partida cadastrada</div>
      )}
    </div>
  );
};

export default ChavePrintSection;

